// import React, { useState } from 'react';
// import { FaChevronRight } from 'react-icons/fa';
import moment from "moment";
import { FiDownload } from "react-icons/fi";
// import { useNavigate } from 'react-router-dom';

const AssetAssignedComponent = ({
  viewall,
  need,
  heading,
  travelData,
  handleDownloadCSV,
  dropdownOptions,
  selectedOption,
  handleOptionChange,
}) => {
  // const navigate = useNavigate();
  return (
    <div className="min-w-full container mx-auto bg-white shadow-md rounded-lg">
      <div className="bg-white rounded-t-lg p-4 flex flex-row   space-x-6 items-center justify-between">
        <div className="relative w-full ">
          <h2 className="text-xl font-semibold :text-left">{heading}</h2>
        </div>
        {need ? (
          <div className="w-[500px] flex justify-end  ">
            <button
              onClick={handleDownloadCSV}
              className="p-2 bg-gray-200 rounded-md flex items-center space-x-1 w-full  justify-center "
            >
              <span>Download CSV</span>
              <FiDownload className="w-4 h-4 " />
            </button>
          </div>
        ) : null}
      </div>
      <div className="overflow-x-auto bg-white rounded-b-lg">
        <table className="min-w-full overflow-hidden">
          <thead className="bg-gray-100">
            <tr className="bg-gray-100 text-left">
              <th className="px-4 p-4  text-sm font-medium text-gray-600 text-center w-1/4 min-w-[150px]">
                Resource Type
              </th>
              <th className="px-4 p-4  text-sm font-medium text-gray-600 text-center w-2/4 min-w-[250px]">
                Details
              </th>
              <th className="px-4 p-4 text-sm font-medium text-gray-600 text-center w-1/4 min-w-[150px]">
                Date Assigned
              </th>
            </tr>
          </thead>
          <tbody className="text-sm text-gray-800">
            {travelData.length > 0
              ? travelData?.slice(0, 3).map((row, idx) => (
                  <tr key={idx} className="border-b last:border-none ">
                    <td className="p-4 text-gray-800 text-center">
                      {row.assetType}
                    </td>
                    <td className="p-4 text-gray-800 text-center">
                      {row.details ? row.details : "-"}
                    </td>
                    <td className="p-4 text-gray-800 text-center">
                      {moment(row.createdAt).format("MMM DD, YYYY")}
                    </td>
                  </tr>
                ))
              : travelData?.map((row, idx) => (
                  <tr key={idx} className="border-b last:border-none ">
                    <td className="p-4 text-gray-800 text-center">
                      {row.resource}
                    </td>
                    <td className="p-4 text-gray-800 text-center">
                      {row.details}
                    </td>
                    <td className="p-4 text-gray-800 text-center">
                      {moment(row.createdAt).format("MMM DD, YYYY")}
                    </td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
      {travelData.length === 0 ? (
        <p className="p-4 text-gray-800 text-center">
          No any assigned assets found
        </p>
      ) : null}
      {/* {viewall && travelData.length > 3 ?
                <div className="p-4 py-6 flex justify-end">
                    <a onClick={() => {
                        navigate('/call-history');

                    }} className="text-sm text-black flex items-center">
                        View All <FaChevronRight className="ml-1" />
                    </a>
                </div>
                :
                <div className=" pb-2">
                </div>
            } */}
    </div>
  );
};

export default AssetAssignedComponent;
